import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withCtx as _withCtx, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = {
  key: 0,
  class: "st_myreg_customize_form"
}
const _hoisted_5 = {
  name: "myreg_form",
  ENCTYPE: "multipart/form-data",
  style: {"margin":"0"}
}
const _hoisted_6 = { class: "st_myreg_form" }
const _hoisted_7 = { style: {"display":"inline-block","cursor":"pointer"} }
const _hoisted_8 = { style: {"display":"inline-block","cursor":"pointer"} }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "st_myreg_form" }
const _hoisted_13 = { class: "st_myreg_form st_myreg_mgt myreg_cnt_use" }
const _hoisted_14 = { style: {"display":"inline-block","cursor":"pointer"} }
const _hoisted_15 = { style: {"display":"inline-block","cursor":"pointer"} }
const _hoisted_16 = ["min", "max"]
const _hoisted_17 = ["min", "max"]
const _hoisted_18 = { class: "st_myreg_form st_myreg_mgt myreg_cnt_use" }
const _hoisted_19 = { id: "total_price_str" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["min", "max"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 0,
  class: "no-data",
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_24 = {
  key: 1,
  style: {"max-height":"500px","overflow-y":"auto"}
}
const _hoisted_25 = { style: {"display":"flex","justify-content":"flex-end"} }

import { ref, onMounted, computed, h, watch } from "vue"; // h 추가
import { useRoute, useRouter } from "vue-router"; // $route 접근을 위해 useRoute 임포트
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common.ts";
import * as constant from "@/constants/constant";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import {
  NModal,
  NIcon,
  NRadio,
  NDataTable,
  NButton,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui"; // NButton, NRadio, NDataTable 추가
import { ChevronForward } from "@vicons/ionicons5"; // ChevronForward는 템플릿 다른 곳에서 사용될 수 있으므로 유지

import { useAuth } from "@/composables/useAuth";
import { Product, ProductGroup } from "@/model/product";
import Loading from "@/components/Loading.vue"; // Loading 컴포넌트 임포트
import { useActionDialog } from "@/composables/useDialog";
import { useAlertDialog } from "@/composables/useAlert";
const createOrder = "createOrder";

export default /*@__PURE__*/_defineComponent({
  __name: 'Registration',
  setup(__props) {

const { isLoggedIn, loggedInUserId, isOrgUser, isOrgAdmin } = useAuth();
const { show: showActionDialog } = useActionDialog();
const useAlert = useAlertDialog();

watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

const message = useMessage();
const notification = useNotification();
const dialog = useDialog(); // useDialog는 confirmTestRequest에서 사용

const getPersonalProductCallable = getCallable("getProductGroups");
const productGroupList = ref<ProductGroup[]>([]);
const selectedProductGroup = ref<ProductGroup | null>(null);

const getCallApiCallable = getCallable("callApi");
const remote_getMyExaminees = getCallable("getMyExaminees");

const isLoading = ref(false);
const isHistoryLoading = ref(false);
const isProcess = ref(false);
const isHovered = ref(false);
const availableYears = ref<number[]>([]);
const test_target_date = ref("");
const test_target_date_min = ref("");
const test_target_date_max = ref("");
const counsel_target_date = ref("");

const bank_date = ref("");
const bank_date_min = ref("");
const bank_date_max = ref("");

const route = useRoute();
const router = useRouter();

const now = new Date();
test_target_date.value = common.formatDateToYYYY_MM_DD(now);
counsel_target_date.value = common.formatDateToYYYY_MM_DD(now);
test_target_date_min.value = test_target_date.value;
const maxTargetDate = new Date(now);
maxTargetDate.setDate(now.getDate() + 90);
test_target_date_max.value = common.formatDateToYYYY_MM_DD(maxTargetDate);

const currentYear = now.getFullYear() - 6;
const startYear = currentYear - 50;
for (let year = currentYear; year >= startYear; year--) {
  availableYears.value.push(year);
}

bank_date.value = common.formatDateToYYYY_MM_DD(now);
bank_date_min.value = bank_date.value;
const maxBankDate = new Date(now);
maxBankDate.setDate(now.getDate() + 7);
bank_date_max.value = common.formatDateToYYYY_MM_DD(maxBankDate);

const showPersonPop = ref(false);
const ex_name = ref(null);
const ex_gender = ref(null);
const dob_year = ref(null);
const dob_month = ref(null);
const dob_day = ref(null);
const ex_school_info = ref(null);
const examineeInfos = ref([]);
const selectedExamineeKeyInModal = ref<string | null>(null); // 모달 내 선택된 피검자 정보의 키
const deposit_name = ref(null);
const ex_receiver_email = ref(null);
const name = ref(null);
const relationship = ref(null);
const receiver_email = ref(null);
const phone_number = ref(null);
const counsel_type = ref(null);

const address = ref({
  postCode: "",
  address: "",
  addressDetail: "",
});

function closePersonPopup() {
  showPersonPop.value = false;
}
function handlePersonSelection(personData) {
  if (personData) {
    ex_name.value = personData.name;
    dob_year.value = personData.dob.substring(0, 4);
    dob_month.value = personData.dob.substring(4, 6);
    dob_day.value = personData.dob.substring(6, 8);
    ex_gender.value = personData.gender.substring(0, 1);
    ex_school_info.value = personData.school_info;
    ex_receiver_email.value = personData.email;
    address.value = personData.address;
  }

  closePersonPopup(); // 모달 닫기
}
async function fetchMyExamineeInfos() {
  if (examineeInfos.value.length > 0) {
    showPersonPop.value = true; // 이미 정보가 있으면 바로 팝업 표시
    return;
  }
  isHistoryLoading.value = true;
  try {
    const result = await remote_getMyExaminees();
    if (common.evalFunctionResult(result)) {
      const history = common.getItemListFromFunctionResult(result);
      if (!history || history.length == 0) {
        notification.info({
          title: "정보 없음",
          content:
            "과거 검사를 실시한 정보가 없습니다.\n* 검사를 실시하면 피검자 정보가 자동 저장되어 다음 검사 신청시 불러올 수 있습니다.",
          duration: 5000, // 5초
        });
        return;
      } else {
        examineeInfos.value = history;
        showPersonPop.value = true; // 팝업 표시
      }
    } else {
      console.error(
        "fetchMyExamineeInfos - 데이터 가져오기 실패:",
        common.getResultError(result)
      );
      notification.error({
        title: "오류",
        content: "피검자 정보를 가져오는 데 실패했습니다.",
        duration: 3000,
      });
      return [];
    }
  } catch (error: any) {
    console.error("fetchMyExamineeInfos - API 호출 실패:", error);
    notification.error({
      title: "오류",
      content: `피검자 정보 로딩 중 오류: ${error.message}`,
      duration: 3000,
    });
    return [];
  } finally {
    isHistoryLoading.value = false;
  }
}

const examineeTableColumns = computed(() => [
  {
    title: "선택",
    key: "selection",
    width: 70,
    align: "center",
    render(row: any) {
      // row는 examineeInfos 배열의 각 항목 (프로젝트 객체)
      const projectKey =
        row.SK || row.examinees[0]?.name + row.examinees[0]?.dob; // 고유 키 생성
      return h(NRadio, {
        name: "examineeSelectionGroupInModal", // 라디오 그룹명
        checked: selectedExamineeKeyInModal.value === projectKey,
        value: projectKey, // 라디오 버튼의 값으로 고유 키 사용
        onUpdateChecked: (checked: boolean) => {
          if (checked) {
            selectedExamineeKeyInModal.value = projectKey;
          }
        },
      });
    },
  },
  {
    title: "검사이름",
    key: "name",
    resizable: true,
  },
  {
    title: "검사실시일",
    key: "start_target_date",
    resizable: true,
    render: (row: any) => common.getYYYMMDDStringFormat(row.start_target_date),
  },
  {
    title: "이름",
    key: "examineeName",
    resizable: true,
    render: (row: any) => row.examinees[0]?.name || "N/A",
  },
  {
    title: "성별",
    key: "examineeGender",
    resizable: true,
    render: (row: any) => {
      return common.getGenderString(row.examinees[0]?.gender);
    },
  },
  {
    title: "생년월일",
    key: "examineeDob",
    resizable: true,
    render: (row: any) => row.examinees[0]?.dob || "N/A",
  },
]);

function confirmExamineeSelectionFromModal() {
  if (selectedExamineeKeyInModal.value) {
    const selectedProject = examineeInfos.value.find(
      (p: any) =>
        (p.SK || p.examinees[0]?.name + p.examinees[0]?.dob) ===
        selectedExamineeKeyInModal.value
    );
    if (
      selectedProject &&
      selectedProject.examinees &&
      selectedProject.examinees.length > 0
    ) {
      handlePersonSelection(selectedProject.examinees[0]); // 기존 함수 재활용
    }
  }
  selectedExamineeKeyInModal.value = null; // 선택 초기화
  closePersonPopup(); // 모달 닫기
}

function _checkAvailableConfirm() {
  // 모든 에러 메시지가 비어있어야 유효
  return (
    !exNameError.value &&
    !depositNameError.value &&
    !dobError.value &&
    !genderError.value &&
    !receiverEmailError.value &&
    !testTargetDateError.value &&
    !bankDateError.value &&
    !exReceiverEmailError.value &&
    !exSchooclInfoError.value &&
    !addressError.value &&
    !nameError.value &&
    !relationshipError.value &&
    !phoneNumberError.value &&
    !counselTypeError.value &&
    !counselTargetDateError.value
  );
}

function _getErrorMessage() {
  let message = "입력값을 확인하세요.";

  if (exNameError.value) return exNameError.value;
  if (genderError.value) return genderError.value;
  if (dobError.value) return dobError.value;
  if (exSchooclInfoError.value) return exSchooclInfoError.value;
  if (addressError.value) return addressError.value;
  if (exReceiverEmailError.value) return exReceiverEmailError.value;
  if (nameError.value) return nameError.value;
  if (relationshipError.value) return relationshipError.value;
  if (receiverEmailError.value) return receiverEmailError.value;
  if (phoneNumberError.value) return phoneNumberError.value;
  if (counselTypeError.value) return counselTypeError.value;
  if (counselTargetDateError.value) return counselTargetDateError.value;
  if (testTargetDateError.value) return testTargetDateError.value;
  if (depositNameError.value) return depositNameError.value;
  if (bankDateError.value) return bankDateError.value;

  return message;
}
const exNameError = computed(() => {
  if (!ex_name.value) return `피검자명을 입력해야 합니다.`;
  return "";
});
const depositNameError = computed(() => {
  if (!deposit_name.value) return `입금자명을 입력해야 합니다.`;
  return "";
});
const dobError = computed(() => {
  if (!dob_year.value || !dob_month.value || !dob_day.value)
    return `피검자 생년월일을 지정해야 합니다.`;
  const dob = `${dob_year.value}${dob_month.value}${dob_day.value}`;
  if (dob.length !== 8) return `피검자 생년월일 형식이 올바르지 않습니다.`;
  // 추가적인 날짜 유효성 검사 (예: 2월 30일 등)는 필요시 common.isValidDate 같은 함수로 구현
  return "";
});
const genderError = computed(() => {
  if (!ex_gender.value) return `피검자 성별을 지정해야 합니다.`;
  return "";
});
const receiverEmailError = computed(() => {
  if (!receiver_email.value) return "보호자 이메일을 입력해야 합니다.";
  // Basic email format validation using a regular expression
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(receiver_email.value))
    return "올바른 이메일 형식이 아닙니다.";
  return "";
});
const testTargetDateError = computed(() => {
  if (!test_target_date.value) return "검사 실시일을 선택해야 합니다.";
  return "";
});
const bankDateError = computed(() => {
  if (!bank_date.value) return "입금 예정일을 선택해야 합니다.";
  return "";
});

const exReceiverEmailError = computed(() => {
  if (!ex_receiver_email.value) return "피검자 이메일을 입력해야 합니다.";
  // Basic email format validation using a regular expression
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(ex_receiver_email.value))
    return "올바른 이메일 형식이 아닙니다.";
  return "";
});
const exSchooclInfoError = computed(() => {
  if (!ex_school_info.value) return "소속 학교 | 학년을 입력해야 합니다.";
  return "";
});
const addressError = computed(() => {
  if (!address.value.postCode) return "학교 주소를 입력해야 합니다.";
  return "";
});
const nameError = computed(() => {
  if (!name.value) return "보호자 성명을 입력해야 합니다.";
  return "";
});
const relationshipError = computed(() => {
  if (!relationship.value) return "피검자와의 관계를 입력해야 합니다.";
  return "";
});
const phoneNumberError = computed(() => {
  if (!phone_number.value) return "핸드폰 번호를 입력해야 합니다.";
  // Basic email format validation using a regular expression
  const phoneRegex = /^\d{2,3}-\d{3,4}-\d{4}$/;
  if (!phoneRegex.test(phone_number.value))
    return "전화번호 형식이 올바르지 않습니다. (예: 02-123-4567 또는 010-1234-5678)";
  return "";
});

const counselTypeError = computed(() => {
  if (!counsel_type.value) return "상담 방법을 선택해야 합니다.";
  return "";
});

const counselTargetDateError = computed(() => {
  if (!counsel_target_date.value) return "상담코칭 예정일을 선택해야 합니다.";
  return "";
});
async function confirmTestRequest() {
  if (!_checkAvailableConfirm()) {
    let errorMessase = _getErrorMessage();
    notification.error({
      title: "입력 오류",
      content: errorMessase,
      duration: 3000,
    });
    return;
  }

  showActionDialog({
    title: "확인",
    content: "검사 신청을 진행하시겠습니까?",
    positiveText: "네",
    negativeText: "아니요",
    positiveButtonProps: { type: "primary" },
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      const cAuth = common.getLocalAuth();
      if (!cAuth) {
        notification.error({
          title: "오류",
          content: "로그인 정보가 없습니다.",
          duration: 3000,
        });

        isProcess.value = false;
        isLoading.value = false;
        message.destroyAll();
        return;
      }

      const dob = `${dob_year.value}${dob_month.value}${dob_day.value}`;
      const testTargetDate = test_target_date.value.replace(/-/g, "");
      const counselTargetDate = counsel_target_date.value.replace(/-/g, "");
      let orderProducts: any[] = [];
      if (selectedProductGroup.value && selectedProductGroup.value.products) {
        orderProducts = selectedProductGroup.value.products.map(
          (productItem) => {
            return {
              prod_id: productItem.SK, // 상품(Product)의 SK
              name: productItem.name,
              price: productItem.price,
              type: productItem.type, // Product 모델에 type이 있다면 사용
              personal_template_form_id: productItem.personal_template_form_id, // Product 모델에 있다면 사용
              projects: [
                {
                  num: 1,
                  name: productItem.name, // 각 상품의 이름으로 설정
                  start_target_date: testTargetDate,
                  counsel_target_date: counselTargetDate,
                  counsel_type: counsel_type.value,
                  examinees: [
                    {
                      num: 1,
                      name: ex_name.value,
                      gender: ex_gender.value,
                      dob: dob,
                      school_info: ex_school_info.value,
                      address: address.value,
                      email: ex_receiver_email.value,
                    },
                  ],
                },
              ],
            };
          }
        );
      } else {
        notification.error({
          title: "오류",
          content: "선택된 상품 정보가 없습니다.",
          duration: 3000,
        });
        message.destroyAll();
        return;
      }

      let payload = {
        client: cAuth,
        payment_method: {
          type: "bank_deposit",
          deposit_name: deposit_name.value,
          bank_date: bank_date.value,
          bank_name: "우리은행 : 1005-104-783814",
        },
        totalPrice: selectedProductGroup.value
          ? selectedProductGroup.value.price
          : 0,
        receiver_email: receiver_email.value,
        products: orderProducts,
        guardian: {
          name: name.value,
          relationship: relationship.value,
          phone_number: phone_number.value,
        },
        type: constant.orderType.INDIVIDUAL,
      };

      try {
        const result = await getCallApiCallable(
          makeCallApiParam(createOrder, payload)
        );
        message.destroyAll(); // 이전 로딩 메시지 제거
        if (common.evalFunctionResult(result)) {
          notification.success({
            title: "성공",
            content:
              "신청이 접수되었습니다.\n입금 및 관리자의 승인 후 진단이 가능합니다.",
            duration: 3000,
          });
          router.push({ name: USER_ROUTES.Mypage.Order.Personal.Name });
        } else {
          throw new Error(
            common.getResultError(result) || "신청 처리 중 오류가 발생했습니다."
          );
        }
      } catch (error: any) {
        message.destroyAll();
        console.error("confirmTestRequest API 호출 실패:", error);
        notification.error({
          title: "신청 실패",
          content:
            common.getResultError(error) || "신청 처리 중 오류가 발생했습니다.",
          duration: 3000,
        });
      }
    },
    onCancel: () => {
      message.info("신청이 취소되었습니다.");
    },
  });
}

async function fetchProducts() {
  const productKey = route.params.product_key as string;
  if (!productKey) {
    notification.error({
      title: "오류",
      description: "상품 키가 제공되지 않았습니다.",
      duration: 3000,
    });
    return;
  }
  isLoading.value = true;
  try {
    const result = await getPersonalProductCallable({}); // 모든 상품 그룹 가져오기
    if (common.evalFunctionResult(result)) {
      const allProductGroups = common.getItemListFromFunctionResult(
        result
      ) as ProductGroup[];
      productGroupList.value = allProductGroups;
      const foundProductGroup = allProductGroups.find(
        (group) => group.product_key === productKey
      );
      if (foundProductGroup) {
        selectedProductGroup.value = foundProductGroup;
      } else {
        notification.error({
          title: "오류",
          description: `상품(키: ${productKey})을 찾을 수 없습니다.`,
          duration: 3000,
        });
        selectedProductGroup.value = null;
      }
    } else {
      notification.error({
        title: "오류",
        description: `상품 목록 조회 실패: ${common.getResultError(result)}`,
        duration: 3000,
      });
      selectedProductGroup.value = null;
    }
  } catch (err: any) {
    console.error("fetchProducts 에러:", err);
    notification.error({
      title: "심각한 오류",
      description: `상품 목록을 가져오는 중 예외가 발생했습니다: ${err.message}`,
      duration: 3000,
    });
    selectedProductGroup.value = null;
  } finally {
    isLoading.value = false;
  }
}

const openPostcodeSearch = async () => {
  if (
    typeof (window as any).daum === "undefined" ||
    typeof (window as any).daum.Postcode === "undefined"
  ) {
    await useAlert(
      "Daum 우편번호 서비스가 로드되지 않았습니다. 페이지를 새로고침하거나 관리자에게 문의하세요."
    );
    return;
  }
  new (window as any).daum.Postcode({
    oncomplete: (data: any) => {
      let addr = ""; // 주소 변수
      let extraAddr = ""; // 참고항목 변수

      //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
      if (data.userSelectedType === "R") {
        // 사용자가 도로명 주소를 선택했을 경우
        addr = data.roadAddress;
      } else {
        // 사용자가 지번 주소를 선택했을 경우(J)
        addr = data.jibunAddress;
      }

      // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
      if (data.userSelectedType === "R") {
        // 법정동명이 있을 경우 추가한다. (법정리는 제외)
        // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
        if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
          extraAddr += data.bname;
        }
        // 건물명이 있고, 공동주택일 경우 추가한다.
        if (data.buildingName !== "" && data.apartment === "Y") {
          extraAddr +=
            extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
        }
        // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
        if (extraAddr !== "") {
          extraAddr = " (" + extraAddr + ")";
        }
      }

      address.value.postCode = data.zonecode;
      address.value.address = addr + extraAddr;
    },
  }).open();
};

onMounted(async () => {
  fetchProducts();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isLoggedIn))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Banner, {
            title: "",
            subtitle: "",
            description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
          }),
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createVNode(Loading, null, null, 512), [
              [_vShow, isLoading.value]
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[67] || (_cache[67] = _createElementVNode("h1", { class: "sub_subject" }, [
                _createTextVNode(" [개인] 검사 및 상담코칭 신청서 작성"),
                _createElementVNode("span")
              ], -1)),
              (_unref(isLoggedIn))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("form", _hoisted_5, [
                      _createElementVNode("table", _hoisted_6, [
                        _cache[40] || (_cache[40] = _createElementVNode("caption", null, " 피검자 기본정보 ", -1)),
                        _cache[41] || (_cache[41] = _createElementVNode("colgroup", null, [
                          _createElementVNode("col", { style: {"width":"220px"} }),
                          _createElementVNode("col")
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[24] || (_cache[24] = _createElementVNode("th", null, [
                              _createTextVNode("성 명 "),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "ex_name",
                                id: "ex_name",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ex_name).value = $event))
                              }, null, 512), [
                                [_vModelText, ex_name.value]
                              ]),
                              _createVNode(_unref(NButton), {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchMyExamineeInfos())),
                                loading: isHistoryLoading.value,
                                type: "primary",
                                size: "small",
                                ghost: "",
                                style: {"margin-left":"8px"}
                              }, {
                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                  _createTextVNode(" 기존정보 불러오기 ")
                                ])),
                                _: 1
                              }, 8, ["loading"])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[27] || (_cache[27] = _createElementVNode("th", null, [
                              _createTextVNode("성별 "),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _createElementVNode("label", _hoisted_7, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  name: "ex_gender",
                                  id: "ex_gender_m",
                                  value: "m",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ex_gender).value = $event))
                                }, null, 512), [
                                  [_vModelRadio, ex_gender.value]
                                ]),
                                _cache[25] || (_cache[25] = _createElementVNode("span", null, "남", -1))
                              ]),
                              _createElementVNode("label", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  name: "ex_gender",
                                  id: "ex_gender_f",
                                  value: "f",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ex_gender).value = $event))
                                }, null, 512), [
                                  [_vModelRadio, ex_gender.value]
                                ]),
                                _cache[26] || (_cache[26] = _createElementVNode("span", null, "여", -1))
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[34] || (_cache[34] = _createElementVNode("th", null, [
                              _createTextVNode("생년월일 "),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("select", {
                                name: "dob_year",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dob_year).value = $event))
                              }, [
                                _cache[28] || (_cache[28] = _createElementVNode("option", {
                                  disabled: "",
                                  value: ""
                                }, "----", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableYears.value, (year) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: year,
                                    value: year
                                  }, _toDisplayString(year), 9, _hoisted_9))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, dob_year.value]
                              ]),
                              _cache[31] || (_cache[31] = _createTextVNode(" 년 ")),
                              _withDirectives(_createElementVNode("select", {
                                name: "dob_month",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dob_month).value = $event))
                              }, [
                                _cache[29] || (_cache[29] = _createElementVNode("option", { value: "" }, "--", -1)),
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
                                  return _createElementVNode("option", {
                                    key: m,
                                    value: String(m).padStart(2, '0')
                                  }, _toDisplayString(String(m).padStart(2, "0")), 9, _hoisted_10)
                                }), 64))
                              ], 512), [
                                [_vModelSelect, dob_month.value]
                              ]),
                              _cache[32] || (_cache[32] = _createTextVNode(" 월 ")),
                              _withDirectives(_createElementVNode("select", {
                                name: "dob_day",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dob_day).value = $event))
                              }, [
                                _cache[30] || (_cache[30] = _createElementVNode("option", { value: "" }, "--", -1)),
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (day) => {
                                  return _createElementVNode("option", {
                                    key: day,
                                    value: String(day).padStart(2, '0')
                                  }, _toDisplayString(String(day).padStart(2, "0")), 9, _hoisted_11)
                                }), 64))
                              ], 512), [
                                [_vModelSelect, dob_day.value]
                              ]),
                              _cache[33] || (_cache[33] = _createTextVNode(" 일 "))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[35] || (_cache[35] = _createElementVNode("th", null, [
                              _createTextVNode(" 소속 학교 | 학년(또는 학과, 전공 등)"),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "ex_school_info",
                                id: "ex_school_info",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ex_school_info).value = $event))
                              }, null, 512), [
                                [_vModelText, ex_school_info.value]
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[37] || (_cache[37] = _createElementVNode("th", null, [
                              _createTextVNode("우편번호"),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "postCode",
                                id: "postCode",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((address.value.postCode) = $event)),
                                style: {"width":"120px"},
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, address.value.postCode]
                              ]),
                              _createVNode(_unref(NButton), {
                                onClick: openPostcodeSearch,
                                size: "small",
                                style: {"margin-left":"5px"}
                              }, {
                                default: _withCtx(() => _cache[36] || (_cache[36] = [
                                  _createTextVNode(" 주소검색 ")
                                ])),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[38] || (_cache[38] = _createElementVNode("th", null, [
                              _createTextVNode("학교 주소"),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "address",
                                id: "address",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((address.value.address) = $event)),
                                style: {"width":"100%"},
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, address.value.address]
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[39] || (_cache[39] = _createElementVNode("th", null, [
                              _createTextVNode("Email 주소"),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "ex_receiver_email",
                                id: "ex_receiver_email",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ex_receiver_email).value = $event))
                              }, null, 512), [
                                [_vModelText, ex_receiver_email.value]
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("table", _hoisted_12, [
                        _cache[46] || (_cache[46] = _createElementVNode("caption", null, " 보호자 기본정보 ", -1)),
                        _cache[47] || (_cache[47] = _createElementVNode("colgroup", null, [
                          _createElementVNode("col", { style: {"width":"220px"} }),
                          _createElementVNode("col")
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[42] || (_cache[42] = _createElementVNode("th", null, [
                              _createTextVNode("성 명 "),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "name",
                                id: "name",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((name).value = $event))
                              }, null, 512), [
                                [_vModelText, name.value]
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[43] || (_cache[43] = _createElementVNode("th", null, [
                              _createTextVNode(" 피검자와의 관계"),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "relationship",
                                id: "relationship",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((relationship).value = $event))
                              }, null, 512), [
                                [_vModelText, relationship.value]
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[44] || (_cache[44] = _createElementVNode("th", null, [
                              _createTextVNode("Email 주소"),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "receiver_email",
                                id: "receiver_email",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((receiver_email).value = $event))
                              }, null, 512), [
                                [_vModelText, receiver_email.value]
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[45] || (_cache[45] = _createElementVNode("th", null, [
                              _createTextVNode("핸드폰 번호"),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "phone_number",
                                id: "phone_number",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((phone_number).value = $event))
                              }, null, 512), [
                                [_vModelText, phone_number.value]
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("table", _hoisted_13, [
                        _cache[55] || (_cache[55] = _createElementVNode("caption", null, " 상품 신청 및 진행 상세정보 ", -1)),
                        _cache[56] || (_cache[56] = _createElementVNode("colgroup", null, [
                          _createElementVNode("col", { style: {"width":"180px"} }),
                          _createElementVNode("col")
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[48] || (_cache[48] = _createElementVNode("th", null, "신청 상품", -1)),
                            _createElementVNode("td", null, [
                              _createElementVNode("ul", null, [
                                (selectedProductGroup.value)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(selectedProductGroup.value.products, (item) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: item.PK
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[51] || (_cache[51] = _createElementVNode("th", null, [
                              _createTextVNode("상담 방법"),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _createElementVNode("label", _hoisted_14, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  name: "counsel_type",
                                  id: "counsel_type_offline",
                                  value: "offline",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((counsel_type).value = $event))
                                }, null, 512), [
                                  [_vModelRadio, counsel_type.value]
                                ]),
                                _cache[49] || (_cache[49] = _createElementVNode("span", null, "연구소 내방", -1))
                              ]),
                              _createElementVNode("label", _hoisted_15, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  name: "counsel_type",
                                  id: "counsel_type_online",
                                  value: "online",
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((counsel_type).value = $event))
                                }, null, 512), [
                                  [_vModelRadio, counsel_type.value]
                                ]),
                                _cache[50] || (_cache[50] = _createElementVNode("span", null, "On-Line", -1))
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[53] || (_cache[53] = _createElementVNode("th", null, [
                              _createTextVNode("검사 실시일 "),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                name: "s_v7",
                                min: `${test_target_date_min.value}`,
                                max: `${test_target_date_max.value}`,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((test_target_date).value = $event)),
                                id: "datepicker_s_v7",
                                style: {"width":"120px"}
                              }, null, 8, _hoisted_16), [
                                [_vModelText, test_target_date.value]
                              ]),
                              _cache[52] || (_cache[52] = _createElementVNode("span", { style: {"color":"red"} }, " - 검사 실시 예정일로부터 15일 안에 검사를 실시하여야 합니다.", -1))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[54] || (_cache[54] = _createElementVNode("th", null, [
                              _createTextVNode(" 상담코칭 예정일"),
                              _createElementVNode("span", { class: "st_myreg_required" }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                name: "s_v8",
                                min: `${test_target_date_min.value}`,
                                max: `${test_target_date_max.value}`,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((counsel_target_date).value = $event)),
                                id: "datepicker_s_v8",
                                style: {"width":"120px"}
                              }, null, 8, _hoisted_17), [
                                [_vModelText, counsel_target_date.value]
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("table", _hoisted_18, [
                        _cache[65] || (_cache[65] = _createElementVNode("caption", null, " 결제 정보 ", -1)),
                        _cache[66] || (_cache[66] = _createElementVNode("colgroup", null, [
                          _createElementVNode("col", { style: {"width":"180px"} }),
                          _createElementVNode("col")
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[57] || (_cache[57] = _createElementVNode("th", null, "신청 상품", -1)),
                            _createElementVNode("td", null, [
                              _createElementVNode("ul", null, [
                                (selectedProductGroup.value)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(selectedProductGroup.value.products, (item) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: item.PK
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[60] || (_cache[60] = _createElementVNode("th", null, "결제 금액", -1)),
                            _createElementVNode("td", null, [
                              (selectedProductGroup.value && selectedProductGroup.value.price)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[58] || (_cache[58] = _createElementVNode("input", {
                                      type: "hidden",
                                      name: "total_price",
                                      id: "total_price",
                                      value: "{{ selectedProductGroup.price : 0 }}"
                                    }, null, -1)),
                                    _createElementVNode("span", _hoisted_19, _toDisplayString(selectedProductGroup.value.price.toLocaleString()) + "원", 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[59] || (_cache[59] = _createElementVNode("input", {
                                      type: "hidden",
                                      name: "total_price",
                                      id: "total_price",
                                      value: "0"
                                    }, null, -1)),
                                    (selectedProductGroup.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "0원"))
                                      : _createCommentVNode("", true)
                                  ], 64))
                            ])
                          ]),
                          _cache[64] || (_cache[64] = _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "결제계좌"),
                            _createElementVNode("td", null, "우리은행 : 1005-104-783814, 예금주:주식회사코코랩")
                          ], -1)),
                          _createElementVNode("tr", null, [
                            _cache[62] || (_cache[62] = _createElementVNode("th", null, [
                              _createTextVNode("입금자명"),
                              _createElementVNode("span", { style: {"color":"red"} }, "*.")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "deposit_name",
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((deposit_name).value = $event)),
                                id: "deposit_name",
                                style: {"width":"120px"},
                                class: "st_myreg_input_txt"
                              }, null, 512), [
                                [_vModelText, deposit_name.value]
                              ]),
                              _cache[61] || (_cache[61] = _createElementVNode("p", { class: "error-message" }, " * 입금자명은 반드시 피검자 성명으로 기재해야 합니다. ", -1))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[63] || (_cache[63] = _createElementVNode("th", null, [
                              _createTextVNode("입금 예정일"),
                              _createElementVNode("span", { style: {"color":"red"} }, "*")
                            ], -1)),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                name: "bank_date",
                                min: `${bank_date_min.value}`,
                                max: `${bank_date_max.value}`,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((bank_date).value = $event)),
                                id: "bank_date",
                                style: {"width":"120px"}
                              }, null, 8, _hoisted_21), [
                                [_vModelText, bank_date.value]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", { class: "st_myreg_btn_wrap" }, [
                      _createElementVNode("button", {
                        onClick: confirmTestRequest,
                        class: "st_myreg_btn_type1 st_myreg_highlight"
                      }, " 신청하기 ")
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, "로그인 후 사용해 주세요."))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(NModal), {
      show: showPersonPop.value,
      "onUpdate:show": [
        _cache[21] || (_cache[21] = ($event: any) => ((showPersonPop).value = $event)),
        _cache[22] || (_cache[22] = (value) => showPersonPop.value = value)
      ],
      preset: "card",
      style: {"width":"750px"},
      title: "피검자 정보 선택",
      "mask-closable": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_unref(NButton), {
            onClick: confirmExamineeSelectionFromModal,
            disabled: !selectedExamineeKeyInModal.value,
            type: "primary",
            style: {"margin-right":"10px"}
          }, {
            default: _withCtx(() => _cache[69] || (_cache[69] = [
              _createTextVNode("선택")
            ])),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(NButton), { onClick: closePersonPopup }, {
            default: _withCtx(() => _cache[70] || (_cache[70] = [
              _createTextVNode("닫기")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (!examineeInfos.value || examineeInfos.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[68] || (_cache[68] = [
              _createElementVNode("p", null, "선택할 인물 정보가 없습니다.", -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(_unref(NDataTable), {
                columns: examineeTableColumns.value,
                data: examineeInfos.value,
                "single-line": false,
                "row-key": (row) => row.SK || (row.examinees[0]?.name + row.examinees[0]?.dob)
              }, null, 8, ["columns", "data", "row-key"])
            ]))
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})